import PaymentModal from './PaymentModal.view';

export default PaymentModal;
